module.exports = __webpack_public_path__ + "img/mastercard.36fcc7d8.svg";